/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateOfBirth/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DateOfBirth({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/PatientOptions/New/DateOfBirth",
  isInvalid,
  onChange
  
}) {
let appointmentOverlayPatientNewPersonBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.birth_date',
format: fromFormat.dateISOIn,
})
let appointmentOverlayPatientNewPersonBirthDateIsValidData = fromData.useDataIsValid({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.birth_date',
validate: fromValidate.birthday,
required: true,
})
let appointmentOverlayPatientNewPersonBirthDateChangeData = fromData.useDataChange({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.birth_date',
formatOut: fromHelpers.formatOutDate,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="DateOfBirth.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 size="small"
 data="appointment_overlay.patient_new.person.birth_date"
 format="/Data/format.js dateISOIn"
 formatOut="helpers.js formatOutDate"
 validate="/Data/validate.js birthday"
 required={true}
 invalid={!appointmentOverlayPatientNewPersonBirthDateIsValidData}
 value={appointmentOverlayPatientNewPersonBirthDateValueData}
 onChange={appointmentOverlayPatientNewPersonBirthDateChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 type="text"
 mask="date"
 placeholder="mm/dd/yyyy *"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}